// @flow

import * as React from 'react';
import { Table, Tag, Button, Empty } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import moment from 'moment';

type Props = {
  project: {},
  feedback: [],
  onClickDownloadFeedback: Function,
}

export default class extends React.PureComponent<Props> {

  getStatusColor = (status) => {
    switch (status) {
      case 'sent':
        return 'blue';
      case 'read':
        return 'orange';
      case 'completed':
        return 'green';
      default:
        return 'default';
    }
  }

  getStatusText = (status) => {
    switch (status) {
      case 'sent':
        return 'Sent';
      case 'read':
        return 'Opened';
      case 'completed':
        return 'Completed';
      default:
        return status;
    }
  }

  render () {

    const { feedback, onClickDownloadFeedback } = this.props;

    const columns = [
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Contact',
        dataIndex: 'contact_name',
        key: 'contact_name',
        render: (text) => text || '-',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (status) => (
          <Tag color={this.getStatusColor(status)}>
            {this.getStatusText(status)}
          </Tag>
        ),
      },
      {
        title: 'Requested',
        dataIndex: 'requested_at',
        key: 'requested_at',
        render: (date) => moment(date).format('MMM D, YYYY h:mm A'),
      },
      {
        title: 'Submitted',
        dataIndex: 'submitted_at',
        key: 'submitted_at',
        render: (date) => date ? moment(date).format('MMM D, YYYY h:mm A') : '-',
      },
      {
        title: 'Requested By',
        dataIndex: 'requested_by',
        key: 'requested_by',
        render: (text) => text || '-',
      },
      {
        title: 'Actions',
        key: 'actions',
        render: (_, record) => (
          record.status === 'completed' ? (
            <Button
              type="link"
              icon={<DownloadOutlined />}
              onClick={() => this.props.onClickDownloadFeedback(record)}
            >
              Download PDF
            </Button>
          ) : null
        ),
      },
    ];

    if (!feedback || feedback.length === 0) {
      return (
        <Empty
          description="No feedback requests yet"
          style={{ marginTop: 40 }}
        />
      );
    }

    return (
      <Table
        columns={columns}
        dataSource={feedback}
        rowKey="id"
        pagination={false}
      />
    )
  }
}
